/*
 * File: getCategoryProducts.ts
 * Project: meki
 * File Created: Monday, 3rd May 2021 2:55:03 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th December 2022 3:33:55 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Category, ProductConnection } from '@interfaces';

export const getCategoryProducts = () => gql`
  query getCategoryProducts(
    $params: BestSellingProductsCategoryParams!
    $categoryParams: GetCategoryParams!
  ) {
    bestSellingProductsCategory(params: $params) {
      pageInfo {
        totalPages
        pageNumber
      }
      nodes {
        id
        uuid
        slug
        name
        price
        concentration
        unit
        quantity
        package
        composition
        display
        containerQuantity
        container
        availability {
          status
        }
        categories {
          id
          name
          slug
        }
        imagesUrl
        activePrinciple
        laboratory
        isCheapestActivePrinciple
        discount {
          price
          listPrice
          type
          stockRestriction
          dateRestriction
        }
      }
      brands {
        brand
        quantity
      }
    }

    category(params: $categoryParams) {
      id
      name
      slug
    }
  }
`;

export type getCategoryProductsQueryParams = {
  params: {
    slug: string;
    pageNumber: number;
    filterBy?: {
      brands?: string[];
      priceRanges?: {
        start?: number;
        stop?: number;
      }[];
    };
    sortBy?: {
      price: boolean;
      alphabetically: boolean;
      mostSelling: boolean;
    };
  };
  categoryParams: {
    slug: string;
  };
};

export type getCategoryProductsQueryResponse = {
  bestSellingProductsCategory: ProductConnection;
  category: Category;
};
